import { FormInstance, Checkbox, Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ReactNode } from 'react';

interface FormCheckboxProps {
  name: string;
  checked: boolean;
  onChange: (e: CheckboxChangeEvent) => void;
  label: string;
  form: FormInstance;
  initialValue?: boolean;
  show?: boolean;
  icon?: ReactNode;
  disabled?: boolean;
}

const FormCheckbox = ({
  name,
  checked,
  onChange,
  label,
  form,
  initialValue = false,
  show = true,
  icon,
  disabled = false,
}: FormCheckboxProps) => {
  if (!show) return null;

  return (
    <div className={`flex items-center gap-2 ${disabled ? 'opacity-60' : ''}`}>
      <Form.Item
        initialValue={initialValue}
        name={name}
        className='mb-0'
        valuePropName='checked'
        noStyle
      >
        <Checkbox
          id={`checkbox-${name}`}
          checked={form.getFieldValue(name)}
          onChange={onChange}
          className='custom-checkbox-round'
          disabled={disabled}
        />
      </Form.Item>
      <label
        htmlFor={`checkbox-${name}`}
        className={`text-sm leading-5 text-sd-foreground flex items-center gap-1.5 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      >
        {icon}
        {label}
      </label>
    </div>
  );
};

export default FormCheckbox;
